<template>
  <div class="space-y-4 p-4">
    <div class="w-full space-y-2">
      <form @submit.prevent="buscarComprobantes">
        <div class="flex flex-col items-center gap-x-6 gap-y-4 sm:flex-row sm:items-end">
          <div class="flex items-center gap-6">
            <div class="flex flex-col">
              <label
                for="fatura-codigo"
                class="ml-1 whitespace-nowrap text-sm font-medium text-gray-700"
                >Cód. factura</label
              >
              <input
                id="fatura-codigo"
                v-input-filter="value => /^[a-zA-Z]*$/.test(value)"
                v-model="facturaCodigo"
                class="w-40 appearance-none rounded-md border border-gray-400 p-2 text-gray-900 placeholder-gray-700 transition duration-150 ease-in-out focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 sm:text-sm"
              />
            </div>
            <div class="flex flex-col">
              <label
                for="factura-numero"
                class="ml-1 whitespace-nowrap text-sm font-medium text-gray-700"
                >Nro. factura</label
              >
              <input
                id="factura-numero"
                v-input-filter="value => /^\d*$/.test(value)"
                v-model="facturaNumero"
                class="w-40 appearance-none rounded-md border border-gray-400 p-2 text-gray-900 placeholder-gray-700 transition duration-150 ease-in-out focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 sm:text-sm"
              />
            </div>
          </div>
          <button
            class="w-fit space-x-2 whitespace-nowrap rounded-md border px-3 py-2 text-sm font-medium"
            :class="{
              'border-blue-brand-700 bg-blue-brand-500 text-blue-brand-100 transition duration-150 ease-in-out hover:bg-blue-brand-700 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-blue-brand-700':
                canSearch,
              'border-gray-300 bg-gray-100 text-gray-400': !canSearch,
            }"
            :disabled="!canSearch"
            type="submit"
          >
            Buscar
          </button>
        </div>
      </form>
    </div>

    <ComprobantesFactura
      v-if="search.codigo && search.numero"
      :facturaCodigo="search.codigo"
      :facturaNumero="search.numero"
      :key="search.codigo + search.numero"
    />
  </div>
</template>

<script>
import { useSession } from '@colescba/ui'

import ComprobantesFactura from '@/components/DevolucionComprobantes/ComprobantesFactura'

export default {
  components: { ComprobantesFactura },

  mixins: [useSession()],

  data() {
    return {
      isLoading: false,
      facturaCodigo: null,
      facturaNumero: null,
      search: {
        codigo: null,
        numero: null,
      },
    }
  },

  computed: {
    canSearch() {
      return this.facturaCodigo && this.facturaNumero
    },
  },

  methods: {
    buscarComprobantes() {
      this.search.codigo = this.facturaCodigo.toLowerCase()
      this.search.numero = this.facturaNumero
    },
  },
}
</script>
